import React, { Component } from "react";
import { useHistory } from "react-router-dom";
import "pure-react-carousel/dist/react-carousel.es.css";
import "./FeaturedCarouselItems.css";
import plusButton from "../../../assets/img/plus-button.svg";
import { Button, Col, Row } from "reactstrap";
import ReactHtmlParser from "react-html-parser";
import Slider from "react-slick";
import { useSelector } from "react-redux";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}

const FeaturedCarouselItem = (props) => {
  const {translationState , allWebContent} = useSelector((state) => state.user)
  const {userLanguage} = useSelector((state) => state.auth);
  const homeFeature = allWebContent?.[0]?.homeFeature;
  const homeFeatureTranslation = translationState?.[0]?.translations?.homeFeature?.[userLanguage]

  const history = useHistory();
  const { user } = useSelector(
    (state) => state.auth
  );
  const { sliderItems, viewProduct } = props;

  // Console log the products data
  console.log("🔍 FEATURED CAROUSEL DEBUG:");
  console.log("Props received:", props);
  console.log("Slider items:", sliderItems);
  console.log("Number of items:", sliderItems?.length);
  console.log("View product function:", viewProduct);
  
  if (sliderItems && sliderItems.length > 0) {
    console.log("First product details:", sliderItems[0]);
    console.log("All products:", sliderItems);
  } else {
    console.log("❌ No slider items found!");
  }

  const settings = {
    speed: 500,
    slidesToShow: sliderItems.length >= 4 ? 4 : sliderItems.length,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,

    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  console.log("🎨 RENDERING FEATURED CAROUSEL:");
  console.log("Slider items length:", sliderItems?.length);
  console.log("Will show slides:", sliderItems.length >= 4 ? 4 : sliderItems.length);

  return (
    <div className="container-fluid position-relative mt-5 pt-xl-5">
      <div className="slick-container">
        <h2 className="header-font font-weight-light text-center mb-3 mb-md-4 mb-xl-5">
          {" "}
          {homeFeatureTranslation?.featured ? homeFeatureTranslation?.featured : homeFeature?.featured}
          {/* Featured in our platform */}
          {" "}
        </h2>
        <div className="">
          <Slider className="features" {...settings}>
            {sliderItems.map((item, index) => {
              // Extract the actual product data from the advertisement object
              const product = item.productId || item;
              
              // Console log each individual product
              console.log(`📦 Product ${index + 1}:`, {
                id: product._id || product.id,
                name: product.name,
                brand: product.brand,
                images: product.images,
                price: product.price,
                dynamicPrice: product.dynamicPrice,
                productType: product.productType,
                isPaidAd: true, // These are all paid ads since they're from advertisements
                fullItem: item,
                actualProduct: product
              });
              
              return (
                <div className="featured-carousel" key={index}>
                  {/* image wrapper - matching product-preview-container */}
                  <div className="featured-carousel-image-wrapper">
                    <img
                      className="featured-carousel-image"
                      src={product.images?.[0] || '/default-product-image.jpg'}
                      alt={`Product image for ${product.name || 'product'}`}
                    />
                  </div>

                  {/* EXACT COPY of product-preview-container structure */}
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ width: "75%" }}>
                      <div className="featured-carousel-name-text">
                        {product.name || 'Product Name'}
                      </div>
                      <div className="featured-carousel-brand-text">
                        {product.brand || 'Brand'}
                      </div>
                    </div>
                    <button
                      className="featured-carousel-add-button"
                      onClick={() => {
                        viewProduct(product, user);
                      }}
                      aria-label={`Add ${product.name || 'product'} to cart`}
                    >
                      <img src={plusButton} alt="Add to cart" />
                    </button>
                  </div>
                </div>
              );
            })}
          </Slider>
        </div>
        <div className="mx-auto text-center pt-5 pb-1">
          <button
            onClick={() => history.push("/search")}
            className="btn black-bg-btn button-text py-2 px-4"
          >
          {homeFeatureTranslation?.buttonFeatured ? homeFeatureTranslation?.buttonFeatured : homeFeature?.buttonFeatured}

            {/* Shop More */}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeaturedCarouselItem;
